import { useCallback } from "react";

// TODO: use if

const legacyModals = {
  subscription: '.js-update-subscription-modal',
  cancel: '.js-cancel-subscription-confirmation-modal',
  update_account: '.js-account-details-modal',
  update_payment: '.js-payment-details-modal',
  common_billing_questions: '.js-common-billing-questions',
  integration: '.js-integration-modal',
  gmail_integration: '.js-gmail-integration-modal'
};

export const useLegacyModal = (modalId: keyof typeof legacyModals) => {
  const modal = legacyModals[modalId];
  if (!modal) {
    throw new Error(`No modal with id ${modalId} found`);
  }

  const setOpen = useCallback((open: boolean) => {
    const element = document.querySelector(modal) as HTMLDivElement | null;
    if (!element) {
      return
    }
    if (open) {
      element.classList.remove('hidden');
      element.classList.add('legacy-popper-show');
      element.style.display = 'block';
    } else {
      element.classList.add('hidden');
      element.classList.remove('legacy-popper-show');
      element.style.display = 'none';
    }
  }, []);

  return {
    setOpen,
  };
}